<template>
  <div id="dashboard-analytics">
    <vs-popup classContent="popup-example" title="Error!!!" :active.sync="genralErrorFlag">
      <div class="modal-body">

        <div>
                      <div class="form-group">
                        <label for="exampleInputEmail1" style="color: #a94442;">{{errorText}}</label>
                      </div>




                    </div>
        <br>
        <vs-button
          ref="loadableButton"
          id="button-with-loading"
          class="vs-con-loading__container mt-2"
          @click="logOut()"
          type="relief"
          style="float: none !important;"
        >Login Again</vs-button>
  </div>
      </vs-popup>
    <vx-card slot="no-body h-full" class="d-theme-dark-light-bg mb-base">
      <vs-alert :active.sync="errorFlag" closable icon-pack="feather" close-icon="icon-x" color="danger" title="ERROR!!!" style="text-align: center;" @click="dismissError()">
      {{errorText}}
    </vs-alert>
      <div class="vx-row">
        <h1
          class="p-2 font-bold w-full text-primary"
          style="border-bottom: 2px solid;"
        >
          Upload Bulk UPI Mandate Deduction Data
        </h1>
        <div class="vx-col w-full lg:w-1/3 mb-base">
          <div class="mt-2">
            <template>
              <v-file-input
                v-model="file"
                color="deep-purple accent-4"
                counter

                placeholder="Select your files"
                prepend-icon="mdi-paperclip"
                outlined
                :show-size="1000"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip
                    v-if="index < 2"
                    color="deep-purple accent-4"
                    dark
                    label
                    small
                    >{{ text }}</v-chip
                  >

                  <span
                    v-else-if="index === 2"
                    class="overline grey--text text--darken-3 mx-2"
                    >+{{ file.length - 2 }} File(s)</span
                  >
                </template>

              </v-file-input>
              <div class="col-md-12 text-center" style="color:#4caf50;">{{successMessage}}</div>
            </template>
          </div>
        </div>

          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in tablist"
          />
        </vs-select>
        <div class="mt-4 vx-col w-full lg:w-1/3">
          <vs-button
            ref="loadableButton"
            id="button-with-loading"
            class="vs-con-loading__container"
            @click="upiFileUpload()"
            type="relief"
            style="float: none !important;"
            >Submit</vs-button
          >
        </div>
      </div>


      <span class="font-bold">UPI Mandate Details</span>
      <template>
        <vs-table

          v-model="selected"
          pagination
          max-items="100"
          search
          :data="upiMandateDetails"
        >
          <template slot="thead">
            <vs-th sort-key="email">CustomerID</vs-th>
            <vs-th sort-key="username">Amount</vs-th>
            <vs-th sort-key="website">Status</vs-th>
            <vs-th sort-key="id">Message</vs-th>

          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="row" :key="indextr" v-for="(row, indextr) in data">
              <vs-td >
                {{row.customerID}}
              </vs-td>

              <vs-td>
                {{row.Amount}}
              </vs-td>

              <vs-td >
                {{row.status}}
              </vs-td>

              <vs-td >
                {{row.message}}
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>
      </template>

    </vx-card>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      tabSelected: 1,
        selected: [],
      tablist: [
        { text: "swiggy", value: "swiggy" },
        { text: "uber", value: "uber" },

      ],
      successMessage: "",
        showButton: true,
        file_type: "",
        file: null,

        rows:'',
        errorFlag:false,
        errorText:'',
        errorMessage:'',
        successMessage : '',
        genralErrorFlag:false,
        responseData:[],

    };
  },
  components: {},
  created() {

  },
  methods: {
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr);
    },
    logOut:function()
    {
      this.$router.push({
          path: '/',
          query: {},
      });
    },


  upiFileUpload() {
    this.$store.commit("routeChange", "start");
    this.successMessage = "";
    console.log("display file name " + this.file);
    var timestamp = Math.round(+new Date() / 1000);
    var userip = this.$store.getters.ipAddress
    /*
               Initialize the form data
               */
    let formData = new FormData();

    /*
               Add the form data we need to submit
               */
    formData.append("authLoginID", this.$store.getters.loginId);
    formData.append("ipAddress", userip);
    formData.append("timestamp", timestamp);
    formData.append("authToken", localStorage.getItem("authtoken"));
    formData.append("docType", "UPIMandateDeduction");
    formData.append("bulkUPIMandate", this.file);
    formData.append("format", "xlsx");

    /*
               Make the request to the POST /single-file URL
               */
    const instance = axios.create();

    // Override timeout default for the library
    // Now all requests using this instance will wait 2.5 seconds before timing out
    instance.defaults.timeout = 6000000;

    instance
      .post("mlBulkUPIMandateDeduction", formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      .then(response => {
        console.log("SUCCESS!!");
        const JSONData = response.data;
        if (JSONData.data.error == 0) {
          
          this.successMessage = JSONData.data.message;
          this.upiMandateDetails = JSONData.data.upiMandateDetails

        }

        else {
          this.errorText = JSONData.data.message;
          if(this.errorText === 'Invalid login' || this.errorText === 'sessionTimeout')
          {
            this.genralErrorFlag = true
          }
          else
          {
              this.errorText = JSONData.data.message;
              this.errorFlag  = true
          }
            this.$store.commit("routeChange", "end");

        }
        this.$store.commit("routeChange", "end");

      })
      .catch(error => {
        this.errorText = "Server Connectivity Issue"
        this.errorFlag  = true
          this.$store.commit("routeChange", "end");
      });
  },


  },
};
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>
